import { LoadingStandAloneChat } from "components/LoadingStandAloneChat";
import { StandAloneLiveChat } from "components/StandAloneLiveChat";

interface LiveChatSectionProps {
  channelName: string | null;
  isChatReady: boolean;
}

export function LiveChatSection(props: LiveChatSectionProps) {
  const { channelName, isChatReady } = props;

  if (!isChatReady || channelName === null) {
    return <LoadingStandAloneChat />;
  }

  return <StandAloneLiveChat channelName={channelName} />;
}
